module.exports = "<div class=\"card col-md-2\">\r\n    <div class=\"card-body\">\r\n        <h3>Exception example</h3>\r\n        <hr />\r\n        <div class=\"text-center\">\r\n            <button type=\"button\" class=\"btn btn-danger\" (click)=\"triggerException()\">Trigger Exception</button>\r\n            <hr />\r\n            <p>Trigger a server side exception by clicking the button.</p>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/exception-example/exception-example.component.html
// module id = ./src/app/components/examples/exception-example/exception-example.component.html
// module chunks = main